export const OidcDefaults = {
  syncMode: "FORCE",
  clientAuthMethod: "client_secret_post",
};
